<template>
  <v-app>
    <NavigationBar />
    <v-main>
      <v-container fluid class="pa-2 pa-md-4">
        <router-view />
      </v-container>
    </v-main>
    <AppFooter />
  </v-app>
</template>

<script>
import NavigationBar from './components/NavigationBar.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  name: 'App',
  components: {
    NavigationBar,
    AppFooter,
  },
}
</script>